import { useEffect, useRef } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { ArrowClockwise } from '@phosphor-icons/react'
import { toast } from 'sonner'

export function PWAUpdatePrompt() {
  const toastIdRef = useRef<string | number | undefined>(undefined)

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      console.log('Service Worker registered:', swUrl)
      
      // Check for updates every hour
      if (registration) {
        setInterval(() => {
          registration.update()
        }, 60 * 60 * 1000)
      }
    },
    onRegisterError(error) {
      console.error('SW registration error:', error)
    },
  })

  useEffect(() => {
    if (needRefresh && !toastIdRef.current) {
      const handleUpdate = () => {
        updateServiceWorker(true)
        setNeedRefresh(false)
        toast.dismiss(toastIdRef.current)
        toastIdRef.current = undefined
      }

      const handleDismiss = () => {
        setNeedRefresh(false)
        toast.dismiss(toastIdRef.current)
        toastIdRef.current = undefined
      }

      toastIdRef.current = toast(
        <div className="flex items-start gap-3 w-full">
          <div className="shrink-0 mt-0.5">
            <ArrowClockwise size={20} weight="bold" />
          </div>

          <div className="flex-1 min-w-0">
            <div className="font-semibold text-sm">
              Update Available
            </div>
            <div className="text-sm mt-1 opacity-90">
              A new version of GearLens is available. Reload to update.
            </div>
            <div className="flex justify-end gap-2 mt-3">
              <button
                onClick={handleDismiss}
                className="px-3 py-1.5 text-sm font-medium rounded-md bg-secondary text-secondary-foreground hover:bg-secondary/80 transition-colors"
              >
                Later
              </button>
              <button
                onClick={handleUpdate}
                className="px-3 py-1.5 text-sm font-medium rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                Reload Now
              </button>
            </div>
          </div>
        </div>,
        {
          duration: Infinity,
          onDismiss: () => {
            setNeedRefresh(false)
            toastIdRef.current = undefined
          },
          onAutoClose: () => {
            setNeedRefresh(false)
            toastIdRef.current = undefined
          },
        }
      )
    }
  }, [needRefresh, updateServiceWorker, setNeedRefresh])

  return null
}
